import { Icon20Check } from '@vkontakte/icons';
import { Button, Cell, Headline, List, SizeType } from '@vkontakte/vkui';
import { Popper } from '@vkontakte/vkui/unstable';
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { useWebSearchClickAway } from 'reactApp/ui/Header/WebSearch/hooks/useWebSearchClickAway';
import { createGaSender } from 'reactApp/utils/ga';
import { sendNewUserGa } from 'reactApp/utils/newUserGa';

import { IOption, typesOptionsList } from '../WebSearch.data';
import styles from './CategoryFilters.css';

const sendGa = createGaSender('search');

interface IProps {
    searchOption?: IOption;
    onSelect: (type: string) => void;
    onReset: () => void;
    rootRef: React.RefObject<HTMLDivElement>;
    targetRef: React.RefObject<HTMLElement>;
    onClickAway: () => void;
}

export const CategoryFilters: React.FC<IProps> = ({ searchOption, onSelect, onReset, rootRef, targetRef, onClickAway }) => {
    const ref = useRef<HTMLDivElement>(null);
    useWebSearchClickAway({ rootRef, ref, onClickAway });
    const isNewUser = useSelector(UserSelectors.isNewUser);

    const optionsList = typesOptionsList.map((item) => ({
        ...item,
        onClick: () => {
            sendGa('item-click', item.id);

            if (isNewUser) {
                sendNewUserGa(item.id, 'search');
            }
            onSelect(item.id);
        },
    }));

    useEffect(() => {
        typesOptionsList.forEach(({ id }) => sendGa('item-show', id));
    }, []);

    return (
        <Popper offsetDistance={10} placement="bottom-end" targetRef={targetRef} forcePortal={false}>
            <div ref={ref} id="dropdownList" data-qa-id="search-options">
                <List className={styles.container}>
                    <Cell
                        sizeY={SizeType.COMPACT}
                        after={
                            searchOption && (
                                <Button className={styles.resetButton} hasHover={false} mode="tertiary" onClick={onReset}>
                                    <Headline>Сбросить</Headline>
                                </Button>
                            )
                        }
                    >
                        <Headline level="1" weight="2">
                            Искать
                        </Headline>
                    </Cell>
                    {optionsList.map(({ id, icon: Icon, text, onClick }) => (
                        <Cell
                            sizeY={SizeType.COMPACT}
                            key={id}
                            before={<Icon />}
                            onClick={onClick}
                            after={searchOption?.id === id && <Icon20Check className={styles.check} />}
                        >
                            {text}
                        </Cell>
                    ))}
                </List>
            </div>
        </Popper>
    );
};

CategoryFilters.displayName = 'CategoryFilters';
